import {
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFileImage,
  FaFileAudio,
  FaFileVideo,
  FaFileArchive,
  FaFileAlt,
  FaFile,
  FaFilePowerpoint,
} from "react-icons/fa";
import { BiSolidFileTxt } from "react-icons/bi";

export const iconsDocs = [
  {
    extension: "pdf",
    icon: <FaFilePdf style={{ color: "#FF0000", fontSize: "24px" }} />,
  },
  {
    extension: "doc",
    icon: <FaFileWord style={{ color: "#2B579A", fontSize: "24px" }} />,
  },
  {
    extension: "docx",
    icon: <FaFileWord style={{ color: "#2B579A", fontSize: "24px" }} />,
  },
  {
    extension: "plain",
    icon: <BiSolidFileTxt style={{ color: "#2B579A", fontSize: "24px" }} />,
  },
  {
    extension: "vnd.openxmlformats-officedocument.wordprocessingml.document",
    icon: <FaFileWord style={{ color: "#2B579A", fontSize: "24px" }} />,
  },
  {
    extension:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    icon: <FaFileExcel style={{ color: "#217346", fontSize: "24px" }} />,
  },
  {
    extension: "xls",
    icon: <FaFileExcel style={{ color: "#217346", fontSize: "24px" }} />,
  },
  {
    extension: "xlsx",
    icon: <FaFileExcel style={{ color: "#217346", fontSize: "24px" }} />,
  },
  {
    extension: "ppt",
    icon: <FaFilePowerpoint style={{ color: "#D24726", fontSize: "24px" }} />,
  },
  {
    extension: "pptx",
    icon: <FaFilePowerpoint style={{ color: "#D24726", fontSize: "24px" }} />,
  },
  {
    extension: "txt",
    icon: <FaFileAlt style={{ color: "#616161", fontSize: "24px" }} />,
  },
  {
    extension: "png",
    icon: <FaFileImage style={{ color: "#FFB900", fontSize: "24px" }} />,
  },
  {
    extension: "jpg",
    icon: <FaFileImage style={{ color: "#FFB900", fontSize: "24px" }} />,
  },
  {
    extension: "jpeg",
    icon: <FaFileImage style={{ color: "#FFB900", fontSize: "24px" }} />,
  },
  {
    extension: "gif",
    icon: <FaFileImage style={{ color: "#FFB900", fontSize: "24px" }} />,
  },
  {
    extension: "svg",
    icon: <FaFileImage style={{ color: "#FFB900", fontSize: "24px" }} />,
  },
  {
    extension: "mp3",
    icon: <FaFileAudio style={{ color: "#8E44AD", fontSize: "24px" }} />,
  },
  {
    extension: "wav",
    icon: <FaFileAudio style={{ color: "#8E44AD", fontSize: "24px" }} />,
  },
  {
    extension: "mp4",
    icon: <FaFileVideo style={{ color: "#FF6347", fontSize: "24px" }} />,
  },
  {
    extension: "mov",
    icon: <FaFileVideo style={{ color: "#FF6347", fontSize: "24px" }} />,
  },
  {
    extension: "avi",
    icon: <FaFileVideo style={{ color: "#000", fontSize: "24px" }} />,
  },

  {
    extension: "zip",
    icon: <FaFileArchive style={{ color: "#FF9900", fontSize: "24px" }} />,
  },
  {
    extension: "rar",
    icon: <FaFileArchive style={{ color: "#FF9900", fontSize: "24px" }} />,
  },
  {
    extension: "default",
    icon: <FaFile style={{ color: "#95A5A6", fontSize: "24px" }} />,
  },
];
export const imagesFormat = [
  {
    extension: "png",
    icon: <FaFileImage style={{ color: "#FFB900", fontSize: "24px" }} />,
  },
  {
    extension: "jpg",
    icon: <FaFileImage style={{ color: "#FFB900", fontSize: "24px" }} />,
  },
  {
    extension: "jpeg",
    icon: <FaFileImage style={{ color: "#FFB900", fontSize: "24px" }} />,
  },
  {
    extension: "gif",
    icon: <FaFileImage style={{ color: "#FFB900", fontSize: "24px" }} />,
  },
  {
    extension: "svg",
    icon: <FaFileImage style={{ color: "#FFB900", fontSize: "24px" }} />,
  },
];
